import { defineComponent as _defineComponent } from 'vue'
import { useForm } from '@/util/useForm';
import { onMounted, ref, watch } from 'vue';
import { formatDate } from '@/util/global';
import {
  createGiftCouponCode,
  exchangeGiftCouponCode,
  getGiftCoupon,
  GiftCoupon,
} from '@/api/marketing/giftCoupon';
import { number } from 'echarts';
import { useGlobalFunction } from '@/pinia/modules/globalFunction';
import { getPermission } from '@/pinia/modules/permission';
import { useRoute } from '../../../../router/index';
import ModalItem from '@/component/ModalItem/ModalItem.vue';
import { setRegion } from '@/view/repository/region';
import storage from 'baimahu/storage';
import moment, { Moment } from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftCoupon',
  setup(__props) {

const { setGlobalFunction } = useGlobalFunction();

const permission = getPermission('marketing/gift-coupon');

const tableloading = ref<boolean>(false);
const queryParams = ref<{
  title?: string;
  date?: Moment[];
  current?: number;
}>({});
async function query(params = queryParams.value) {
  tableloading.value = true;
  const res = await getGiftCoupon({
    ...params,
    start_time: params?.date?.[0]
      ? parseInt(String(+params?.date?.[0].startOf('day').format('x') / 1000))
      : undefined,
    end_time: params?.date?.[1]
      ? parseInt(String(+params?.date?.[1].endOf('day').format('x') / 1000))
      : undefined,
    date: undefined,
  });
  tableloading.value = false;
  dataSource.value = res?.detail || [];
  if (res?.detail) {
    pagination.value = {
      total: res?.total,
      current: res?.current,
      pageSize: res?.limit,
      showTotal: () => `共${res.total}条，每页${res.limit}条`,
    };
  } else {
    pagination.value = {
      total: res?.total || 1,
      current: 1,
      pageSize: res?.limit || 10,
      showTotal: () => `共${res?.total || 1}条，每页${res?.limit || 10}条`,
    };
  }
}
//检查查询参数变化请求接口刷新数据
watch(
  queryParams,
  (newVal, oldVal) => {
    query(newVal || undefined);
  },
  { immediate: true }
);
// query();
const form = useForm();
//表单提交
function submit(e) {
  //移除表单提交默认事件
  e.preventDefault();
  const formdata = form.value.getFormValue();
  queryParams.value = {
    ...queryParams.value,
    current: 1,
    ...formdata,
  };
}
//重置表单
function clearForm() {
  form.value.resetFields();
  queryParams.value = { current: 1 };
}

const dataSource = ref<GiftCoupon[]>([]);
const pagination = ref<{
  current: number;
  total: number;
  pageSize: number;
  showTotal: () => string;
}>();
function onPagination(page: { current: number; pageSize: number; showTotal: any; total: number }) {
  queryParams.value = {
    ...queryParams.value,
    current: page.current,
  };
}
const createCouponParams = ref<{
  giftcoupon_id?: number;
  number: number;
}>({ number: 0 });
function generateCoupon(giftcoupon_id) {
  createCouponParams.value = { ...createCouponParams.value, giftcoupon_id };
}
async function ok(onLoading, callback) {
  const { giftcoupon_id, number } = createCouponParams.value;
  onLoading();
  if (await createGiftCouponCode(giftcoupon_id || 0, number)) {
    query();
  }
  onLoading();
  callback();
}

const modalForm = useForm();
async function artificial(onLoading, callback) {
  modalForm.value.validateFields(async (err, values) => {
    if (!err) {
      onLoading();
      const res = await exchangeGiftCouponCode({
        giftcoupon_code: values?.code,
        giftcoupon_passwd: values?.passwd,
        mobile: values?.mobile,
        address: values?.address,
        province_name: values?.city_value?.[0],
        city_name: values?.city_value?.[1],
        area_name: values?.city_value?.[2],
        express_name: values?.express_name,
      });
      if (res) {
        modalForm.value?.resetFields?.();
        query();
        callback();
        modalForm.value.resetFields();
      } else {
        modalForm.value.setFields({
          code: {
            value: values?.code,
            errors: [Error('兑换码无效或者密码错误')],
          },
        });
        modalForm.value.setFields({
          passwd: {
            value: values?.passwd,
            errors: [Error('兑换码无效或者密码错误')],
          },
        });
        onLoading();
      }
    }
  });
}
function siteValidator(rule, input, callback) {
  if (input?.length < 3) {
    callback('收件地址必须精确到区');
  }
  callback();
}
const province_list = ref<any[]>([]);
async function initProvince_list() {
  await setRegion();
  province_list.value = storage.getItem('region_list');
}
onMounted(initProvince_list);
const formItemCol = {
  // labelCol: { span: 10 },
  // wrapperCol: { span: 12 },
};

setGlobalFunction({ queryCouponList: query });

return { __sfc: true,setGlobalFunction, permission, tableloading, queryParams, query, form, submit, clearForm, dataSource, pagination, onPagination, createCouponParams, generateCoupon, ok, modalForm, artificial, siteValidator, province_list, initProvince_list, formItemCol, formatDate, number, ModalItem, moment }
}

})